export default "__VITE_PUBLIC_ASSET__485881cb__"